import { KpiCard } from "../../../../Component/AgentComponents/KpiCard";
import { ShieldCheck, FileText, IndianRupee } from "lucide-react";
import { formatCurrency } from "../../../../Component/AdminComponents/formatCurrency";
import { ValueLoader } from "../../../../Component/Common/ValueLoader";

export default function KpiSection({
  dashboardStats,
  loading,
  totalApproved,
  totalPayable,
}) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <KpiCard
        label="Total Warranties"
        value={loading ? <ValueLoader/> : dashboardStats?.total_warranties_count ?? 0}
        subLabel={
          loading
            ? <ValueLoader/>
            : `Active: ${dashboardStats?.active_warranties_count ?? 0}`
        }
        icon={ShieldCheck}
      />

      <KpiCard
        label="Claims Raised"
        value={loading ? <ValueLoader/> : dashboardStats?.open_claims_count ?? 0}
        subLabel={
          loading
            ? <ValueLoader/>
            : `Open Claims`
        }
        icon={FileText}
      />

      {/* <KpiCard
        label="Approved Amount"
        value={loading ? <ValueLoader/> : `₹ ${formatCurrency(totalApproved)}`}
        icon={IndianRupee}
      />

      <KpiCard
        label="Payable Amount"
        value={loading ? <ValueLoader/> : `₹ ${formatCurrency(totalPayable)}`}
        icon={IndianRupee}
      /> */}
    </div>
  );
}




// import { KpiCard } from "../../../../Component/AgentComponents/KpiCard";
// import { ShieldCheck, FileText, IndianRupee } from "lucide-react";
// import { formatCurrency } from "../../../../Component/AdminComponents/formatCurrency";

// export default function KpiSection({
//   warrantiesData,
//   claims,
//   totalApproved,
//   totalPayable,
// }) {
//   return (
//     <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//       <KpiCard
//         label="Total Warranties"
//         value={warrantiesData.length}
//         subLabel={`Active: ${warrantiesData.filter(w => w.status === "Active").length}`}
//         icon={ShieldCheck}
//       />

//       <KpiCard
//         label="Claims Raised"
//         value={claims.length}
//         subLabel={`Open: ${claims.filter(
//           c => ["Pending", "In Progress", "Approved"].includes(c.status)
//         ).length}`}
//         icon={FileText}
//       />

//       {/* <KpiCard
//         label="Approved Amount"
//         value={`₹ ${formatCurrency(totalApproved)}`}
//         icon={IndianRupee}
//       />

//       <KpiCard
//         label="Payable Amount"
//         value={`₹ ${formatCurrency(totalPayable)}`}
//         icon={IndianRupee}
//       /> */}
//     </div>
//   );
// }
